<!-- Main landing page for the application-->
<!-- Loader-->
<ng-container *ngIf = "loading">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
</ng-container>
<!-- end of loader -->
<ng-container *ngIf="!loading">
  <div class="bg-img">
    <br><br>
    <form class="container" [formGroup]="userForm" (ngSubmit)="onSubmit()">

      <h1 style="font-weight: bold; background-color: rgb(30, 0, 85); color:white; text-align: center;">User Sign Up</h1>
      <!-- select role to sign in -->
      <div class="form-row">
          <div id="left">
          <label>
            <h2>Select Type of User</h2>
          </label>
          </div>
          <div id="right">
          <mat-select [formControl]="role" >
            <mat-option>--</mat-option>
            <mat-option *ngFor="let role of roles" [value]="role">
              {{role}}
            </mat-option>
          </mat-select>

            <mat-error  *ngIf="role.hasError('required')">Please choose a Role</mat-error>
          </div>
      </div>

<!-- enter user name and other details -->
      <br>
    <div class="form-row">
      <div id="left">
        <label>
          <h2>User Name</h2>
        </label>
      </div>
      <div id="right">
        <input type="text" formControlName="userName">
        <mat-error *ngIf="userForm.controls['userName'].invalid && userForm.controls['userName'].errors.required"> User Name Required </mat-error>
      </div>


    </div>
      <br>
      <div class="form-row">
      <div id="left"><label><h2>Full Name</h2></label></div>
      <div id="right"><input type="text" formControlName="fullName">
        <mat-error *ngIf="userForm.controls['fullName'].invalid && userForm.controls['fullName'].errors.required">Full Name Required</mat-error>
      </div>

      </div>
      <br>
      <div class="form-row">
      <div id="left"><label><h2>Email</h2></label></div>
      <div id="right"><input type="text" formControlName="email">
      <mat-error *ngIf="userForm.controls['email'].invalid && userForm.controls['email'].errors.required">Email is Required</mat-error>
      <mat-error *ngIf="userForm.controls['email'].invalid && userForm.controls['email'].errors.email">Email Invalid</mat-error>
    </div>
      </div>
      <br><div class="form-row">
      <div id="left"><label><h2>Password</h2></label></div>
      <div id="right"><input type="password" formControlName="password">
      <mat-error *ngIf="userForm.controls['password'].invalid && userForm.controls['password'].errors.required">Password is Required</mat-error>
      <mat-error *ngIf="userForm.controls['password'].invalid && userForm.controls['password'].errors.minlength">Password must be 8 characters</mat-error>
    </div>
      </div>
      <br><div class="form-row">
      <div id="left"><label><h2>Contact Number</h2></label></div>
      <div id="right"><input type="text" formControlName="contactNumber">
      <mat-error *ngIf="userForm.controls['contactNumber'].invalid && userForm.controls['contactNumber'].errors.required">Contact Number is Required</mat-error>
      <mat-error *ngIf="userForm.controls['contactNumber'].invalid && (userForm.controls['contactNumber'].errors.minlength || userForm.controls['contactNumber'].errors.maxlength)">contactNumber must be 10 characters</mat-error></div>
      </div>

      <button  id ="signup" type="submit" class="btn" [disabled]="userForm.invalid">SUBMIT</button>
      <span><button id="signin" class="btn" routerLinkActive="active" [routerLink]='["/signin"]'>Sign In Here</button></span>
    </form>

  </div>

</ng-container>
<!-- end of form for sign up-->